import type { UserInformation } from 'core'
import { createState } from 'shared'
import { computed } from '@preact/signals'

import { initializeMessaging, subscribeToUpdates } from '../events_messaging'
import { application } from '../application'

const userInformation = createState<UserInformation | null>(null)

export const getUserInformation = async () => {
	const { data, error } = await application.value
		.forManagingAccount()
		.getUserInfo()

	// TODO: Handle error
	if (error) {
		return userInformation.updateState(() => null)
	}

	if (data) {
		try {
			await initializeMessaging().then(() =>
				subscribeToUpdates(data.wsSubjects)
			)
			// eslint-disable-next-line @typescript-eslint/no-shadow
		} catch (error) {
			console.error('Error subscribing to updates:', error)
		}

		userInformation.updateState(() => data)

		return true
	}

	return false
}

export const updateOnboardedState = (newState: boolean) =>
	userInformation.updateState(prevState => ({
		...prevState!,
		onboarded: newState
	}))

export const resetUserInformation = () =>
	userInformation.updateState(() => null)

export const userInformationState = userInformation.state

export const username = computed(
	() =>
		userInformationState.peek()!.fullName ||
		userInformationState.peek()!.firstName ||
		userInformationState.peek()!.lastName ||
		userInformationState.peek()!.userHandler!
)
